@if (user) {
  <div class="user-profile-wrapper">
    @if (userForm) {
      <div class="personal-info" [formGroup]="userForm">
        <div class="full-length">
          <h2 class="text-lg">{{ 'Personal information' | translate }}</h2>
          <app-input
            [title]="'Email' | translate"
            formControlName="email"
            [isSubmitRequired]="true"
            [isSubmitted]="isPersonalInfoSubmitted"
          ></app-input>
        </div>
        <app-input
          [title]="'First name' | translate"
          formControlName="given_name"
          [pattern]="NAME_REGEX"
          [pastePattern]="PASTE_NAME_REGEX"
          [isSubmitRequired]="true"
          [isSubmitted]="isPersonalInfoSubmitted"
        ></app-input>
        <app-input
          [title]="'Last name' | translate"
          formControlName="family_name"
          [pattern]="NAME_REGEX"
          [pastePattern]="PASTE_NAME_REGEX"
          [isSubmitRequired]="true"
          [isSubmitted]="isPersonalInfoSubmitted"
        ></app-input>
        @if (userFrRoute && frItems?.length) {
          <app-franchise-input
            [franchises]="frItems"
            [preselectedFranchise]="userFrRoute"
            (frChange)="changeLocation($event)"
          ></app-franchise-input>
          <app-multi-select
            [title]="'Preferred content' | translate"
            [placeholder]="'- Select preferred content -' | translate"
            [preselectedValues]="preselectedContent"
            [isAllSelected]="'All' | translate"
            (itemsChanged)="selectedItems($event)"
            [options]="preferredContentOptions"
          ></app-multi-select>
        }
        <div class="save-btn">
          <app-button
            [ariaLabel]="'Save' | translate"
            [buttonStyleType]="ButtonTypes.PRIMARY_0"
            [disabled]="!isSubmitProfileAvailable"
            [buttonSize]="BUTTON_SIZE.FULL_SIZE"
            (clicked)="savePersonalInfo()">
            {{ 'Save' | translate }}
          </app-button>
        </div>
      </div>
    }

    <!--    <div class="communication-wrapper">-->
    <!--      <h2 class="text-lg">{{ 'Communications'|translate }}</h2>-->
    <!--      <app-info-->
    <!--        [infoText]="'You can subscribe to publications that match your needs and interests. Each week, you\'ll receive an email summary with links to all your subscribed publications.'|translate"></app-info>-->
    <!--      <app-communications-dropdown-->
    <!--        [title]="'Your interests'|translate"-->
    <!--        [placeholder]="'Select interests'|translate"-->
    <!--      ></app-communications-dropdown>-->
    <!--      <div class="save-btn">-->
    <!--        <app-button-->
    <!--          [ariaLabel]="'Save' | translate "-->
    <!--          [buttonStyleType]="ButtonTypes.PRIMARY_0"-->
    <!--          (clicked)="saveCommunication()"-->
    <!--          [buttonSize]="BUTTON_SIZE.FULL_SIZE"-->
    <!--        >{{ 'Save' | translate }}-->
    <!--        </app-button>-->
    <!--      </div>-->
    <!--    </div>-->


    @if (!user['custom:internal']) {
      <form class="password-container" [formGroup]="passwordForm">
        <h2 class="text-lg">{{ 'Password'|translate }}</h2>
        <app-input
          type="password"
          formControlName="currentPassword"
          [title]="'Current password' | translate"
          [isSubmitRequired]="true"
          [isSubmitted]="isPasswordSubmit"
        ></app-input>
        <div>
          <app-input
            type="password"
            formControlName="newPassword"
            [title]="'New password' | translate"
            [isSubmitRequired]="true"
            [isSubmitted]="isPasswordSubmit"
          ></app-input>
          <app-password-validation [passwordRequirements]="passwordRequirements"></app-password-validation>
        </div>
        <app-input
          type="password"
          formControlName="confirmPassword"
          [title]="'Confirm new password' | translate"
          [isSubmitRequired]="true"
          [isSubmitted]="isPasswordSubmit"
        ></app-input>
        <div class="submit-btn">
          <app-button
            [ariaLabel]="'Submit' | translate"
            [buttonStyleType]="ButtonTypes.PRIMARY_0"
            [disabled]="!isSubmitPasswordAvailable || !!user['custom:internal']"
            (clicked)="changePassword()"
            [buttonSize]="BUTTON_SIZE.FULL_SIZE">
            {{ 'Submit' | translate }}
          </app-button>
        </div>
      </form>
      <div class="deletion-wrapper">
        <h2 class="text-lg">{{ 'Account deletion'|translate }}</h2>
        <app-info [infoText]="'This action is permanent and cannot be undone.'|translate"></app-info>
        <div class="delete-btn">
          <app-button
            [ariaLabel]="'Delete account' | translate"
            [buttonStyleType]="ButtonTypes.DESTRUCTIVE_0"
            (clicked)="deleteAccount()"
            [buttonSize]="BUTTON_SIZE.FULL_SIZE"
          >{{ 'Delete account' | translate }}
          </app-button>
        </div>
      </div>
    }
  </div>
}
